export default {
  advert: {
    list: 'Advertisements',
    archiveList: 'Archived',
    add: 'New Advertisement',
    edit: 'Edit Advertisement',
    basicInfo: 'Basic Information',
    deliverySettings: 'Delivery Settings',
    advertName: 'Advertisement Name',
    advertNamePlaceholder: 'Enter an advertisement name',
    advertNameTip: 'Names may be duplicated. Advertisements are distinguished by code. Maximum 30 characters.',
    advertCode: 'Advertisement Code',
    advertType: 'Advertisement Type',
    secondaryScreenAdvert: 'Secondary Screen Advertisement',
    advertTypeTip: 'Advertisement types and channels are independent. Cashier advertisements use the secondary screen.',
    positionType: 'Placement',
    secondaryScreenStandby: 'Secondary Screen Standby',
    standbyPositionTip: 'When the cashier is idle, the advertisement fills the customer-facing screen.',
    secondaryScreenSplit: 'Secondary Screen Split',
    splitPositionTip: 'During cashier operation, half of the screen shows the cart and half shows the advertisement.',
    recommendedSize: 'Recommended size: {size}',
    effectiveRule: 'Effective Rule',
    effectiveRuleTip: 'Channels, placements and times are checked for conflicts. Only one advertisement can be active per store.',
    channelType: 'Channel',
    cashier: 'Cashier',
    channelTypeTip: 'The current prototype supports the cashier channel. More channels will be added in the advertisement center.',
    applicableStores: 'Applicable Stores',
    allStores: 'All Stores',
    specifiedStores: 'Specified Stores',
    specifiedStoreParticipation: 'Specified Stores',
    noStoreSelected: 'No stores selected',
    selectedStores: '{count} stores selected',
    selectStores: 'Select Stores',
    storeDialogTitle: '{name} - Applicable Stores',
    applicableRule: 'Applicability Rule',
    storeTotal: 'Total stores: {count}',
    sequence: 'No.',
    shopName: 'Store Name',
    shopCode: 'Store Code',
    region: 'Region',
    city: 'City',
    enableStatus: 'Enable Status',
    enabled: 'Enabled',
    storeDisabled: 'Disabled',
    deliveryType: 'Delivery Type',
    longTerm: 'Long-term',
    scheduled: 'Scheduled',
    designatedTime: 'Specified Time',
    deliveryTime: 'Delivery Time',
    deliveryTimeTip: 'Long-term delivery has no end time. Specified delivery requires a complete start and end time.',
    to: 'to',
    image: 'Advertisement Images',
    uploadImage: 'Upload Images',
    imageTip: 'Select 1 to 5 images. Their order determines the display order.',
    imageFormatTip: 'Supports JPG and PNG, up to 5 MB each. Recommended size: 1920 × 1080. Maximum 5 images.',
    imageCount: '{count} images',
    advertStatus: 'Advertisement Status',
    timeStatus: 'Time Status',
    creator: 'Created By',
    updateTime: 'Updated At',
    all: 'All',
    draft: 'Draft',
    published: 'Published',
    disabled: 'Disabled',
    notStarted: 'Not Started',
    delivering: 'Delivering',
    ended: 'Ended',
    detail: 'Details',
    publish: 'Publish',
    disable: 'Disable',
    archive: 'Archive',
    unarchive: 'Unarchive',
    deleteDraft: 'Delete Draft',
    confirm: 'Confirm',
    saveDraft: 'Save as Draft',
    saveSuccess: 'Advertisement saved successfully',
    draftSaveSuccess: 'Draft saved successfully',
    publishSuccess: 'Advertisement published successfully',
    discardChangesTitle: 'Discard unsaved changes?',
    discardChangesMessage: 'This page contains unsaved changes. Discarding them cannot be undone.',
    continueEditing: 'Continue Editing',
    discardChanges: 'Discard Changes',
    publishConfirm: {
      conflictTip: '{count} advertisements conflict with the current delivery configuration. Disable the conflicting advertisements first.',
      viewConflict: 'View Conflicting Advertisements',
    },
    conflictDialog: {
      title: 'Conflicting Advertisements',
      alert:
        'The current advertisement conflicts with {count} published advertisements. ' +
        'Disable them first or return to adjust the delivery settings.',
      batchDisable: 'Disable Selected',
      selectTip: 'Select advertisements to disable',
      maxDisableTip: 'You can disable up to 100 advertisements at a time',
      disableConfirmTitle: 'Disable Conflicting Advertisement',
      disableConfirmMessage: 'Disable the conflicting advertisement “{name}”? Delivery will stop immediately and its configuration will be retained.',
      batchDisableConfirmMessage:
        'Disable the {count} selected conflicting advertisements? Delivery will stop immediately and their configurations will be retained.',
      confirmDisable: 'Confirm Disable',
      disableSuccess: 'Disabled successfully',
    },
    specifiedStoreCount: 'Specified stores: {count}',
    specifiedStoreParticipationCount: 'Specified stores participating ({count})',
    actionDialog: {
      publish: {
        title: 'Publish Advertisement',
        description: 'After publishing, the advertisement will start and stop automatically according to its delivery time.',
        warning: 'Before publishing, conflicts in channel, placement, overlapping time, and applicable stores will be checked.',
      },
      disable: {
        title: 'Disable Advertisement',
        description: 'The advertisement will stop immediately. Its configuration will be retained for editing and republishing.',
        warning: '',
      },
      archive: {
        title: 'Archive Advertisement',
        description: 'The advertisement will move to Archived while its status and delivery records remain unchanged.',
        warning: '',
      },
      unarchive: {
        title: 'Unarchive Advertisement',
        description: 'The advertisement will return to the advertisement list with its existing configuration unchanged.',
        warning: '',
      },
      delete: {
        title: 'Delete Draft',
        description: 'The draft cannot be recovered after deletion. Please review its information.',
        warning: '',
      },
    },
    operationSuccess: '{operation} succeeded',
    selectImage: 'Select advertisement images',
    selectStore: 'Select applicable stores',
    selectDeliveryTime: 'Select a delivery time range',
    endTimeAfterStart: 'The delivery end time must be later than the start time',
  },
};
